/// <reference path="../typings.external.d.ts" />
/// <reference path="../typings.angular.d.ts" />

import "style/sass/general.scss";

import "angular";
import "angular-animate";
import "angular-resource";
import "angular-sanitize";
import "angular-messages";
import "angular-aria";
import "angular-file-saver";
import "angular-i18n/fr-fr";
import "angular-material";
import "angular-translate";
import "angular-translate";
import "angular-translate-interpolation-messageformat";
import "angular-translate-storage-cookie";
import "angular-translate-storage-local";
import "angular-ui-router";
import "angular-simple-logger";
import "./core/map/angular-google-maps.min.js";
import "angular-loading-bar";
import "angular-hotkeys";
import "angular-cookies";
import "lodash";
import "messageformat";
import moment from "moment";
import "moment/locale/es";
import "moment/locale/fr";
import "moment/locale/it";
import "moment-timezone";
import "ng-file-upload";
import touchAction from "touch-action";
import "ng-infinite-scroll";
import "angular-google-analytics";

import "./core/core.module";
import "./shared/shared.module";
import "./loki/loki.module";
import "./organization/organization.module";
import "./sales/sales.module";
import "./online-containers/online-containers.module";
import "./sales/edit/item-edit/item-edit.component";
import "./online-containers/edit/item-edit/item-edit.component";
import "./style/icons/icons.module";
import "./thor.routes";
import "materialize-css";
(<any>window).Waves.displayEffect();

import { forEach } from "lodash";
import { Constants, STATE } from "./thor.const";
import { ThorService } from "./thor.service";
import { TranslateCustomHandlerRessource } from "../app/core/i18n/resource";

class ThorConfiguration {
    public static $inject: string[] = [
        "$animateProvider",
        "$compileProvider",
        "$httpProvider",
        "$locationProvider",
        "$mdAriaProvider",
        "$mdDateLocaleProvider",
        "$mdGestureProvider",
        "$urlRouterProvider",
        "cfpLoadingBarProvider",
        "configServiceProvider",
        "uiGmapGoogleMapApiProvider",
        "AnalyticsProvider",
        "localeProvider"
    ];

    constructor(
        $animateProvider,
        $compileProvider,
        $httpProvider: ng.IHttpProvider,
        $locationProvider: ng.ILocationProvider,
        $mdAriaProvider,
        $mdDateLocaleProvider,
        $mdGestureProvider,
        $urlRouterProvider: angular.ui.IUrlRouterProvider,
        cfpLoadingBarProvider,
        configServiceProvider,
        uiGmapGoogleMapApiProvider,
        analyticsProvider,
        localeProvider
    ) {
        const config = configServiceProvider.$get();
        const { language } = localeProvider.$get();

        if (config.enableAngularOptims && config.enableAngularOptims === true) {
            $compileProvider.debugInfoEnabled(false);
            $compileProvider.commentDirectivesEnabled(false);
            $compileProvider.cssClassDirectivesEnabled(false);
        }

        cfpLoadingBarProvider.includeSpinner = false;
        cfpLoadingBarProvider.startSize = 0.3;

        $mdAriaProvider.disableWarnings();

        $mdGestureProvider.skipClickHijack();

        moment.locale(language);

        $mdDateLocaleProvider.formatDate = date => {
            if (!date) {
                return "";
            }
            return moment(date).format("L");
        };

        $mdDateLocaleProvider.parseDate = date => {
            const formattedDate = moment(date, "L", true);
            return formattedDate.isValid() ? formattedDate.toDate() : new Date(NaN);
        };
        $mdDateLocaleProvider.monthHeaderFormatter = date => moment(date).format("MMM Y");

        // Change week display to start on Monday
        $mdDateLocaleProvider.firstDayOfWeek = 1;

        // if the url is not found in states, redirect to 404
        $urlRouterProvider.otherwise(STATE.V2.ERROR_404.url);

        // Use the history API so we don't need `#` before our routes
        $locationProvider.html5Mode(true);

        $httpProvider.interceptors.push("tokenInterceptor");
        $httpProvider.useApplyAsync(true);

        // Disable ng-animate for animate.css animation
        $animateProvider.classNameFilter(/^(?:(?!animated).)*$/);

        uiGmapGoogleMapApiProvider.configure({
            key: config.gmaps.key,
            v: config.gmaps.version,
            libraries: "visualization, places, drawing, geometry",
            language
        });

        if (config.googleAnalytics.enabled) {
            analyticsProvider.setAccount(config.googleAnalytics.id);
        }

        touchAction();
    }
}

class ThorRun {
    public static $inject: string[] = [
        "$location",
        "$log",
        "$mdDialog",
        "$rootScope",
        "$state",
        "$translate",
        "Analytics",
        "maintenanceService",
        "metaService",
        "toaster",
        "utilsService"
    ];

    constructor(
        $location,
        $log,
        $mdDialog,
        $rootScope: ng.IRootScopeService,
        $state,
        $translate: ng.translate.ITranslateService,
        analytics,
        maintenanceService,
        metaService,
        toaster,
        utilsService
    ) {
        const $t = $translate.instant;

        if (!utilsService.isMobile() && !utilsService.isChrome()) {
            const ua = window.navigator.userAgent;
            const confirm = $mdDialog
                .confirm()
                .title($t("navigateur_non_supporte"))
                .textContent($t("il_semblerait_que_vous_utilisez_un_navigateur_internet_non_supporte", [ua]))
                .ok($t("continuer_quand_meme"))
                .cancel($t("telecharger_google_chrome"));

            $mdDialog.show(confirm)
                .then(
                    null,
                    () => {
                        window.open("https://www.google.fr/chrome", "_blank");
                    }
                );
        }

        maintenanceService
            .fetchResponse
            .then(
            res => {
                if (res && res.data.status === "present") {
                    $state.go(STATE.ERROR.MAINTENANCE);
                }
            });

        $rootScope.metaService = metaService;
        const organizationId = $location.search().oId || sessionStorage.getItem("organizationId");
        if (organizationId) {
            sessionStorage.setItem("organizationId", organizationId);
            $location.search("oId", null);
        }

        $rootScope.isOnline = true;
        window.addEventListener("online",  () => {
            toaster.toast({
                message: $t("vous_etes_de_nouveau_connecte"),
                delay: 2000
            });

            $rootScope.isOnline = true;
        });
        window.addEventListener("offline", () => {
            toaster.toast({
                message: $t("connexion_internet_perdue"),
                warn: true
            });

            $rootScope.isOnline = false;
        });

        $rootScope.$on("$stateChangeSuccess", (event, toState) => {
            // redirect sale Live/catalogue to v2
            switch (toState.name) {
                case `${STATE.SALES.EDIT.INFORMATION}`:
                case `${STATE.SALES.EDIT.LOCATION}`:
                case `${STATE.SALES.EDIT.CONDITIONS}`:
                case `${STATE.SALES.EDIT.SHIPPING}`:
                case `${STATE.SALES.EDIT.LIVE}`:
                case `${STATE.SALES.EDIT.ITEMS}`:
                case `${STATE.SALES.EDIT.SUBSCRIPTIONS}`:
                case `${STATE.SALES.EDIT.PAYMENTS}`:
                case `${STATE.SALES.EDIT.STATS}`:
                    window.open(
                        window.location.href.replace(/ventes/, "v2/sales").replace(/conditions/, "fees-and-conditions"),
                        "_self"
                    );
            }
            $rootScope.containerClass = toState.data?.containerClass;
        });

        $rootScope.$on("$stateChangeError", (
            event,
            toState,
            toParams,
            fromState,
            fromParams,
            rejected
        ) => {
            maintenanceService
                .fetchResponse
                .then(res => {
                    if (res && res.data.status === "present") {
                        event.preventDefault();
                        $state.go(STATE.ERROR.MAINTENANCE);
                    } else if (rejected) {
                        if (rejected.toastMessage) {
                            toaster.toast({
                                message: rejected.toastMessage,
                                warn: !!rejected.warn
                            });
                        }

                        if (rejected.error) {
                            $log.error("Error angular $state change", rejected.error);
                        }

                        if (rejected.redirectStateName && rejected.redirectStateName !== toState.name) {
                            event.preventDefault();
                            $state.go(rejected.redirectStateName);
                        }
                    }
                });
        });


        if (!localStorage.getItem("settings")) {
            localStorage.setItem("settings", JSON.stringify(Constants.DEFAULT_LOCAL_SETTINGS));
        } else {
            const localSettings = JSON.parse(localStorage.getItem("settings"));
            forEach(Constants.DEFAULT_LOCAL_SETTINGS, (settingsValue, settingsKey) => {
                if (localSettings[settingsKey] === undefined) {
                    localSettings[settingsKey] = settingsValue;
                }
            });
            localStorage.setItem("settings", JSON.stringify(localSettings));
        }
    }
}

angular
    .module("thor", [
        "ui.router",
        "ngMaterial",
        "ngResource",
        "ngSanitize",
        "ngMessages",
        "ngFileSaver",
        "ngFileUpload",
        "ngCookies",
        "pascalprecht.translate",
        "uiGmapgoogle-maps",
        "angular-google-analytics",
        "cfp.hotkeys",
        "angular-loading-bar",
        "infinite-scroll",
        "loki",
        "thor.core",
        "thor.icons",
        "thor.item-edit",
        "thor.online-item-edit",
        "thor.shared",
        "thor.organization",
        "thor.routes",
        "thor.sales",
        "thor.online-containers",
        "thor.theming"
    ])
    .service("thorService", ThorService)
    .config(ThorConfiguration)
    .factory("translateCustomHandlerFactory", TranslateCustomHandlerRessource)
    .filter("capitalize", () => text => !!text ? text.charAt(0).toUpperCase() + text.substring(1) : text)
    .run(ThorRun)
;
